// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import Icon from 'shared/components/Icon';
import styles from './ReferralChecklist.module.scss';
import cx from 'classnames';
import { SubmissionError } from 'utils/reduxFormWrapper';

class ReferralChecklist extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { checklist: null };
    this.toggle = this.toggle.bind(this);
    this.setNewItemNameRef = this.setNewItemNameRef.bind(this);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
  }

  componentDidMount() {
    api
      .get(`${this.props.apiEndpoint}/referrals/${this.props.referralId}/referral_checklist`)
      .then(response => this.setState({ checklist: response.data.checklist }));
  }

  setNewItemNameRef(input) {
    this.newItemName = input;
  }

  add(e) {
    e.preventDefault();
    const newChecklistItems = this.state.checklist.checklistItems.concat({
      complete: false,
      description: this.newItemName.value,
    });
    this.updateChecklist(newChecklistItems, 'add', this.newItemName.value).then(response => {
      this.newItemName.value = '';
    });
  }

  remove(idx) {
    const itemDescription = this.state.checklist.checklistItems[idx].description;
    const newChecklistItems = this.state.checklist.checklistItems.filter((item, i) => i !== idx);
    this.updateChecklist(newChecklistItems, 'remove', itemDescription);
  }

  updateChecklist(newChecklistItems, action, itemDescription) {
    return api
      .put(`${this.props.apiEndpoint}/referrals/${this.props.referralId}/referral_checklist`, {
        checklist: { checklist_items: newChecklistItems },
        item_action: action,
        item_description: itemDescription,
      })
      .then(response => {
        this.setState({ checklist: { checklistItems: newChecklistItems } });
        this.props.handleSuccess();
        return null;
      })
      .catch(error => {
        if (!(error instanceof SubmissionError)) throw error;
      });
  }

  toggle(e, idx) {
    e.preventDefault();
    const checklistItems = this.state.checklist.checklistItems;
    const alreadyComplete = checklistItems[idx].complete;
    const itemDescription = checklistItems[idx].description;
    const newItem = { ...checklistItems[idx], complete: !alreadyComplete };
    const newChecklistItems = checklistItems.map((item, i) => (i === idx ? newItem : item));
    this.updateChecklist(newChecklistItems, alreadyComplete ? 'uncheck' : 'check', itemDescription);
  }

  render() {
    const { checklist } = this.state;
    const { checkable, editable } = this.props;
    const { toggle, add, remove } = this;

    return (
      <div>
        <div className="modal-header">
          <h3>Referral Checklist</h3>
        </div>
        <div className="modal-body">
          {checklist ? (
            <div data-spec-class="checklist" className={styles.checklist}>
              {checkable ? (
                checklist.checklistItems.map((item, idx) => (
                  <div key={item.description}>
                    <label
                      data-spec-complete={!!item.complete}
                      className={cx({ [styles.complete]: item.complete })}
                    >
                      <input
                        type="checkbox"
                        checked={item.complete}
                        onChange={e => toggle(e, idx)}
                      />
                      &nbsp;
                      <span>{item.description}</span>&nbsp;
                    </label>
                    {editable && (
                      <span
                        title="Remove"
                        className={styles.pointer}
                        data-spec-id={`remove-checklist-item-${idx}`}
                        onClick={() => remove(idx)}
                      >
                        <Icon name="bin" />
                      </span>
                    )}
                  </div>
                ))
              ) : (
                <ul>
                  {checklist.checklistItems.map((item, idx) => (
                    <li
                      key={idx}
                      data-spec-complete={!!item.complete}
                      className={cx({ [styles.complete]: item.complete })}
                    >
                      {item.description}
                    </li>
                  ))}
                </ul>
              )}
              {editable && (
                <div>
                  <form onSubmit={add}>
                    <input type="text" name="newItemName" ref={this.setNewItemNameRef} />{' '}
                    <button type="submit" className="btn btn-primary">
                      Add
                    </button>
                  </form>
                </div>
              )}
            </div>
          ) : (
            <LoadingContent />
          )}
        </div>
      </div>
    );
  }
}

ReferralChecklist.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  referralId: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
  handleSuccess: PropTypes.func, // should be required if editable is true
  checkable: PropTypes.bool.isRequired,
};

export default ReferralChecklist;
